<template lang='pug'>
  .international
    h1.h1.international-title(v-text="$t('sephoraInternational')")
    p.international-description(v-text="$t('discoverInternationalWebsites')")

    .row
      template(v-for='(continents, continentKey) in continentGroups')
        .sephora-continents(:class="continentKey == 'America' || continentKey == 'Oceania' ? 'col-lg-2' : 'col-lg-4 equal-w-country'")
          .sephora-continent(v-for='continent in continents')
            h3.h3(v-text='continentData(continent).name[i18nLanguage]')
            .sephora-countries
              .sephora-country(v-for='country in continentData(continent).countries')
                a.svg-icon.sephora-country-flag(:class='kebabCase(country.name.slug || country.name.lng_en)' :href='country.url' target='_blank' rel='noopener')
                a.sephora-country-name(:href='country.url' v-text='country.name[i18nLanguage]' target='_blank' rel='noopener')
</template>

<i18n>
{
  "lng_en": {
    "sephoraInternational": "Sephora International",
    "discoverInternationalWebsites": "Discover Sephora's international websites.",
    "metaTitle": "International",
    "metaDescription": "Discover Sephora international websites and shop Sephora all around the world!"
  },
  "lng_id": {
    "sephoraInternational": "Sephora International",
    "discoverInternationalWebsites": "Temukan situs internasional Sephora.",
    "metaTitle": "Internasional",
    "metaDescription": "Temukan situs internasional Sephora dan toko Sephora di seluruh dunia!"
  },
  "lng_th": {
    "sephoraInternational": "Sephora International",
    "discoverInternationalWebsites": "พบกับเว็บไซต์ SEPHORA INTERNATIONAL.",
    "metaTitle": "ประเทศอื่น ๆ",
    "metaDescription": "พบกับเว็บไซต์ของเซโฟราในประเทศอื่น ๆ ให้คุณชอปปิงได้จากทั่วทุกมุมโลก"
  },
  "lng_zh": {
    "sephoraInternational": "Sephora國際",
    "discoverInternationalWebsites": "探索Sephora國際網站。",
    "metaTitle": "國際",
    "metaDescription": "探索Sephora國際網站，到不同國家的Sephora購物！"
  },
  "lng_ko": {
    "sephoraInternational": "세포라 인터내셔널",
    "discoverInternationalWebsites": "세포라 웹사이트 살펴보기",
    "metaTitle": "인터내셔널",
    "metaDescription": "세포라 인터내셔널 웹사이트를 살펴보고 전 세계의 세포라에서 쇼핑해보세요! "
  }
}
</i18n>

<script>
import { fullUrl } from '@/modules/services/utilities'
import { continentsWithCountries } from '@/modules/config/countries'
import kebabCase from 'lodash/kebabCase'

export default {
  computed: {
    continentGroups () {
      return continentsWithCountries.reduce((groups, continent) => {
        groups[continent.group] = groups[continent.group] || []
        groups[continent.group].push(continent.name.lng_en)
        return groups
      }, {})
    },
    i18nLanguage: () => I18n.language
  },

  created () {
    this.$store.commit('setSeoMetaTitle', this.$t('metaTitle'))
    this.$store.commit('setSeoMetaDescription', this.$t('metaDescription'))
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },

  methods: {
    kebabCase,
    continentData (name) {
      return continentsWithCountries.find(continent => continent.name.lng_en === name)
    }
  }
}
</script>

<style scoped lang='scss'>
  .international {
    margin-bottom: 30px;

    @include media-breakpoint-up(md) {
      margin-top: 30px;
    }
  }

  .international-title {
    @include font-weight-medium;
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  .international-description {
    margin-bottom: 50px;
  }

  .sephora-countries {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    margin-top: 20px;

    @include media-breakpoint-up(lg) {
      flex-direction: column;
    }
  }

  .equal-w-country .sephora-country {
    width: 45%;
  }

  .equal-w-country .sephora-countries{
    flex-direction: row;
    justify-content: space-between;
  }

  .equal-w-country .sephora-country .sephora-country-flag{
    max-width: 40px;
    width: 100%;
    height: 40px;
  }

  .sephora-country {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    @include media-breakpoint-down(lg) {
      flex: 1 0 50%;
    }

    .sephora-country-name {
      margin-left: 10px;
    }
  }

  .sephora-continents {
    margin-bottom: 15px;

    &:not(:first-child) {
      @include media-breakpoint-up(lg) {
        .sephora-countries {
          border-left: 1px solid $grey-mid;
        }

        .sephora-country-flag {
          margin-left: 10px;
        }

        .sephora-continent {
          h3 {
            margin-left: 10px;
          }
        }
      }

      @include media-breakpoint-up(xl) {
        .sephora-country-flag {
          margin-left: 20px;
        }

        .sephora-continent {
          h3 {
            margin-left: 20px;
          }
        }
      }
    }
  }
</style>
